import React from 'react'

const MailToSuperAdmin = ({ request=null}) => {
    const superAdminEmail = window.localStorage.getItem("SuperAdminEmail");

    const openMailTo = () => {
        const subject = ""
        const body = ""
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${superAdminEmail}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.open(gmailLink, "_blank");
    }

    return (
        <a
            href={`mailto:${superAdminEmail}`}
            onClick={(e) => {
                e.preventDefault();
                openMailTo();
            }}
            style={{ cursor: 'pointer', color: 'blue' }}
            title={"Send email to contact Super Admin"}
        >
            ({superAdminEmail})
        </a>
    );
}

export default MailToSuperAdmin